export interface ForbrugerOplysninger {
    ejendomNr: number;
    navn: string;
    adresse: string;
    postnr: string;
    by: string;
    // postnrby: string;
    indflyttet: Date;
}
